import { getSlug } from '~/utils/data';

export const BOOKING_STAY = 'stay';
export const BOOKING_SHORT_STAY = 'shortStayPopup';

export function getBookingStayPath(slug) {
  return `/book/stay/${getSlug(slug)}`;
}
